<app-dea-widget-wrapper>
  <div class="d-flex justify-content-between">
    <div class="fw-bold">Iscrizioni Digitali</div>
    <div *ngIf="pagination?.items !== undefined" class="fw-light opacity-50">Totale: {{pagination?.items}}</div>
  </div>
  <div class="v-spacer"></div>
  <div class="row m-0 p-0">
    <div class="col m-0 p-0">
      <app-dea-search-bar (text)="onText($event)"></app-dea-search-bar>
    </div>
    <div class="col-auto m-0 p-0 ms-2 d-flex flex-row gap-2">
      <button type="button" mat-stroked-button color="primary" class="fw-bold px-3 py-1 rounded-pill"
        [routerLink]="'statistiche'" [disabled]="loading">
        Statistiche
      </button>
      <button type="button" mat-stroked-button color="primary" class="fw-bold px-3 py-1 rounded-pill"
        (click)="downloadCsvListing()" [disabled]="loading">
        {{loading && loadingType == 'csv' ? 'Esportazione':'Esporta CSV'}} <mat-icon
          *ngIf="loading && loadingType == 'csv'">
          <mat-spinner diameter="18"></mat-spinner>
        </mat-icon>
      </button>
      <button type="button" mat-flat-button color="primary" class="fw-bold px-3 py-1 rounded-pill"
        (click)="refreshData()" [disabled]="loading">
        {{loading && loadingType != 'csv' ? 'Aggiornamento':'Aggiorna'}} <mat-icon
          *ngIf="loading && loadingType != 'csv'">
          <mat-spinner diameter="18"></mat-spinner>
        </mat-icon>
      </button>
    </div>
  </div>
  <div class="v-spacer"></div>
  <ng-template *ngIf="loading && loadingType != 'csv'; then loadingTrue else loadingFalse"></ng-template>
  <ng-template #loadingTrue>
    <div class="d-flex justify-content-center align-items-center" style="height: 96px;">
      <mat-spinner strokeWidth="2" color="primary" diameter="40"></mat-spinner>
    </div>
  </ng-template>
  <ng-template #loadingFalse>
    <ng-template *ngIf="isError; then isErrorTrue else isErrorFalse"></ng-template>
    <ng-template #isErrorTrue>
      <div class="d-flex justify-content-center align-items-center" style="height: 96px;">
        {{error?.message}}
      </div>
    </ng-template>
    <ng-template #isErrorFalse>
      <div class="d-flex flex-column gap-3">
        <div *ngFor="let enrollment of enrollments;" class="row mx-2">
          <div class="fw-bold col-auto m-0 p-0 my-auto" style="width: 20px;">
            @if(enrollment.known) {
            <i class="bi bi-person-badge"
              title="Iscrizione{{enrollment.created_users?'':' non'}} convertita di uno studente già presente in Ring"
              [style]="{color:enrollment.created_users?'var(--success-color)':'var(--warning-color)'}">
            </i>
            } @else {
            <i class="bi bi-check-lg text-red"
              title="Iscrizione{{enrollment.created_users?'':' non'}} convertita di un nuovo studente"
              [style]="{color:enrollment.created_users?'var(--success-color)':'var(--warning-color)'}">
            </i>
            }
          </div>
          <div class="fw-bold col-auto m-0 p-0 my-auto" style="width: 100px;">{{enrollment.shortHash}}</div>
          <div class="col my-auto">ST: {{enrollment.getFirstUserFullName()}}</div>
          <div class="col-auto m-0 p-0 my-auto text-center" style="width: 90px;">
            {{enrollment.anno_scolastico}}
          </div>
          <div class="col my-auto">{{enrollment.anno}}° {{enrollment.dipartimento}}</div>
          <div class="col m-0 p-0 ms-auto text-end my-auto">{{getFormattedDate(enrollment.createdAt)}}</div>
          <div class="col-auto m-0 p-0 ms-4 d-flex flex-column justify-content-center gap-1">
            <div class="fs-075r d-flex flex-row align-items-center gap-1">
              <mat-checkbox class="custom-checkbox" color="primary" [labelPosition]="'after'"
                (change)="onChangeCheckbox(enrollment, 'segreteria_didattica')"
                [checked]="enrollment.segreteria_didattica === true">
              </mat-checkbox>
              <div>Segreteria Didattica</div>
            </div>
            <div class="fs-075r d-flex flex-row align-items-center gap-1">
              <mat-checkbox class="custom-checkbox" color="primary" [labelPosition]="'after'"
                (change)="onChangeCheckbox(enrollment, 'segreteria_amministrativa')"
                [checked]="enrollment.segreteria_amministrativa === true">
              </mat-checkbox>
              <div>Segreteria Amministrativa</div>
            </div>
          </div>
          <div class="col-auto m-0 ms-4 p-0 my-auto">
            <div class="h-full d-flex flex-column justify-content-center">
              <mat-icon class="m-0 p-0 col-auto opacity-25 dea-mat-icon-btn" [matMenuTriggerFor]="menu"
                title="Modifica {{enrollment?.shortHash}}">
                more_vert
              </mat-icon>
              <mat-menu #menu="matMenu">
                @if(!enrollment.created_users) {
                <button mat-menu-item class="dea-mat-icon-btn" (click)="goToEnrollmentFormPage(enrollment.id)"
                  title="Modifica {{enrollment?.shortHash}}">
                  <mat-icon>edit</mat-icon>
                  <span>Modifica</span>
                </button>
                }
                <button mat-menu-item class="dea-mat-icon-btn" (click)="openPreviewPDF(enrollment.id, 'enrollment')"
                  title="Visualizza {{enrollment?.shortHash}}">
                  <mat-icon>visibility</mat-icon>
                  <span>Visualizza</span>
                </button>
                <button mat-menu-item class="dea-mat-icon-btn"
                  (click)="downloadEnrollmentPDF(enrollment.id, 'enrollment')"
                  title="Scarica {{enrollment?.shortHash}}">
                  <mat-icon>download</mat-icon>
                  <span>Scarica</span>
                </button>
                <button mat-menu-item class="dea-mat-icon-btn" (click)="printEnrollmentPDF(enrollment.id, 'enrollment')"
                  title="Stampa {{enrollment?.shortHash}}">
                  <mat-icon>printer</mat-icon>
                  <span>Stampa</span>
                </button>
                <hr>
                <button mat-menu-item class="dea-mat-icon-btn" [matMenuTriggerFor]="vertebrates">
                  <mat-icon>group</mat-icon>
                  <span>Schede Utenti</span>
                </button>
                <mat-menu #vertebrates="matMenu">
                  <button mat-menu-item class="dea-mat-icon-btn" (click)="openPreviewPDF(enrollment.id, 'cards')"
                    title="Visualizza schede Utenti {{enrollment?.shortHash}}">
                    <mat-icon>visibility</mat-icon>
                    <span>Visualizza</span>
                  </button>
                  <button mat-menu-item class="dea-mat-icon-btn" (click)="downloadEnrollmentPDF(enrollment.id, 'cards')"
                    title="Scarica schede Utenti {{enrollment?.shortHash}}">
                    <mat-icon>download</mat-icon>
                    <span>Scarica</span>
                  </button>
                  <button mat-menu-item class="dea-mat-icon-btn" (click)="printEnrollmentPDF(enrollment.id, 'cards')"
                    title="Stampa schede Utenti {{enrollment?.shortHash}}">
                    <mat-icon>printer</mat-icon>
                    <span>Stampa</span>
                  </button>
                </mat-menu>
                @if(!enrollment.created_users) {
                <hr>
                <button mat-menu-item class="dea-mat-icon-btn" (click)="deleteEnrollment(enrollment.id)"
                  title="Elimina {{enrollment?.shortHash}}">
                  <mat-icon>delete</mat-icon>
                  <span>Elimina</span>
                </button>
                }
                @if(!enrollment.created_users) {
                <hr>
                <button mat-menu-item class="dea-mat-icon-btn" (click)="convertEnrollment(enrollment.id)"
                  title="Crea utenti Ring da {{enrollment?.shortHash}}">
                  <mat-icon>group_add</mat-icon>
                  <span>Crea utenti Ring</span>
                </button>
                }
              </mat-menu>
            </div>
          </div>
        </div>
      </div>
      <div class="v-spacer"></div>
      <app-listing-pagination-bar [paginationData]="pagination" (pageEmitter)="onPage($event)">
      </app-listing-pagination-bar>
    </ng-template>
  </ng-template>
</app-dea-widget-wrapper>